import CCModal2025 from "./CCModal2025";
export default CCModal2025;